import Request from '~/providers/Request';
import { URL } from '~/config/uri';

export const fetchCardOwnersAssas = async (input, page, resolve) => {
  const authorizationToken = await Request.getAuth();
  await fetch(
    `${URL}/admin/asaas/card_owners?qs=${input}&page=${page}&perPage=${15}`,
    {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${authorizationToken}`,
      },
    }
  ).then((resp) => {
    resp.json().then((data) => {
      const items = data.data.map((e) => ({
        id: e,
        name: e,
      }));
      resolve({
        total_count: data.meta.total,
        items,
      });
    });
  });
};
